import React from 'react';
import PropTypes from 'prop-types';

import { PHOTO_OBJECT_TYPE } from './types';

export default function LayoutMd({
    images = []
}) {
    const image1 = images[0] || {};
    const image2 = images[1] || {};
    const image3 = images[2] || {};

    const image1Style = image1?.url
        ? { backgroundImage: `url(${image1.url})` }
        : null;
    const image2Style = image2.url
        ? { backgroundImage: `url(${image2.url})` }
        : null;
    const image3Style = image3.url
        ? { backgroundImage: `url(${image3.url})` }
        : null;

    return (
        <div className="sarsa-hero-image-gallery-layout md">
            <div
                className="photo hero"
                style={image1Style}
                role="img"
                aria-label={image1.altText} />
            <div className="gallery-wrapper">
                <div className="stack">
                    <div
                        className="photo gallery one"
                        style={image2Style}
                        role="img"
                        aria-label={image2.altText} />

                    <div
                        className="photo gallery two"
                        style={image3Style}
                        role="img"
                        aria-label={image3.altText} />
                </div>
            </div>
        </div>
    );
}

LayoutMd.propTypes = {
    images: PropTypes.arrayOf(PHOTO_OBJECT_TYPE)
};
